import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import {
	clearInfinityScroll,
	setInfinityScrollOffset,
	setInfinityScrollPage,
	setNotificationsModalIsOpened,
} from 'shared/model';

export const useCommonSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.commonSlice),
		setInfinityScrollOffset: (offset: number) => dispatch(setInfinityScrollOffset(offset)),
		setInfinityScrollPage: (page: number) => dispatch(setInfinityScrollPage(page)),
		clearInfinityScroll: () => dispatch(clearInfinityScroll()),
		setNotificationsModalIsOpened: (opened: boolean) => dispatch(setNotificationsModalIsOpened(opened)),
	};
};
